import { Grid, Paper, Box, Typography, Button, Stack, Chip } from "@mui/material";
import Loader from "Components/Loader";
import ImgPath from "Constants/Imgs";
import { RouteUrls } from "Constants/RouteUrls";
import { DashboardCardType } from "DataTypes/Dashboard.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CaseApi from "Service/Case.api";
import AdminApi from "Service/Admin.api";
import StatusApi from "Service/Status.api";
import { ensureConnected, connection } from "Service/signalRService";
import ContactUsDialog from "./ContactUsDialog";
import CorporateBatchDashboard from "./CorporateBatchDashboard";
import StarIcon from '@mui/icons-material/Star';
import {
  SupportAgent,
  VerifiedUser,
  AssignmentInd,
  AssignmentTurnedIn,
  SettingsPhone,
  AdminPanelSettings,
  Dashboard,
  Groups,
  CurrencyRupee,
  MenuBook,
  Campaign
} from '@mui/icons-material';
import BroadcastNotificationDialog from "./BroadcastNotificationDialog";

const DashboardCards = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState<DashboardCardType[]>([]);
  const [loading, setLoading] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [broadcastDialogOpen, setBroadcastDialogOpen] = useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const handleOpenGuide = () => {
    let pdfPath = "/Assets/PDFs/NoLegalPaisa_User_Guide_Instruction_Booklet_v1_revised.pdf";
    if (myInfo?.userType === "PROFESSIONAL") {
      pdfPath = "/Assets/PDFs/NoLegalPaisa_Professional_Instruction_Booklet_v2_revised.pdf";
    }
    window.open(pdfPath, "_blank");
  };

  const cardData = [
    // {
    //   title: "Earn & Payments",
    //   count: 0,
    //   icon: ImgPath.EarnAndPayIcon,
    //   path: "#",
    // },
    // {
    //   title: "Applicaion & Calender",
    //   // count: 0,
    //   icon: ImgPath.ApplicationCalIcon,
    //   path: "#",
    // },
    ...(myInfo?.userType !== "ADMIN" && myInfo?.userType !== "SUPERADMIN" ? [{
      title: "Contact Us",
      // count: 0,
      // icon: ImgPath.ContactUsIcon,
      icon: <SupportAgent sx={{ fontSize: 45, color: '#1976d2' }} />,
      path: "contact",
    }] : []),

    // ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
    //   ? [
    //       {
    //         title: "Corporate Users",
    //         // count: 0,
    //         icon: ImgPath.KnowledgeBankIcon,
    //         path: `/${RouteUrls.corporateList}`,
    //       },
    //     ]
    //   : []),
    ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Verify Professional Users",
          // count: 0,
          // icon: ImgPath.KnowledgeBankIcon,
          icon: <VerifiedUser sx={{ fontSize: 45, color: '#2e7d32' }} />,
          path: `/${RouteUrls.professionalUsers}`,
        },
      ]
      : []),
    // ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
    //   ? [
    //     {
    //       title: "Assign professional to case",
    //       // count: 0,
    //       // icon: ImgPath.KnowledgeBankIcon,
    //       icon: <AssignmentInd sx={{ fontSize: 45, color: '#0288d1' }} />,
    //       path: `/${RouteUrls.AssignProfessional}`,
    //     },
    //     {
    //       title: "Bulk ODR Neutral Assignment",
    //       icon: <AssignmentInd sx={{ fontSize: 45, color: '#2e7d32' }} />,
    //       path: `/${RouteUrls.BulkAssignNeutral}`,
    //     },
    //   ]
    //   : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Manage ODR Role Privileges",
          icon: <AdminPanelSettings sx={{ fontSize: 45, color: '#9c27b0' }} />,
          path: `/${RouteUrls.ManageOdrRoles}`,
        },
        {
          title: "Broadcast Push Notification",
          icon: <Campaign sx={{ fontSize: 45, color: '#e91e63' }} />,
          path: "broadcast",
        },
      ]
      : []),
    ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Hotline",
          // count: 0,
          // icon: ImgPath.KnowledgeBankIcon,
          icon: <SettingsPhone sx={{ fontSize: 45, color: '#d32f2f' }} />,
          path: `/${RouteUrls.Hotline}`,
        },
      ]
      : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Admin User Management",
          // count: 0,
          // icon: ImgPath.KnowledgeBankIcon,
          icon: <AdminPanelSettings sx={{ fontSize: 45, color: '#7b1fa2' }} />,
          path: `/${RouteUrls.AdminUserManagement}`,
        },
      ]
      : []),
    // ...(myInfo.userType === "SUPERADMIN"
    //   ? [
    //     {
    //       title: "Case Dashboard",
    //       // count: 0,
    //       // icon: ImgPath.ActiveOrdersIcon,
    //       icon: <Dashboard sx={{ fontSize: 45, color: '#455a64' }} />,
    //       path: `/${RouteUrls.CaseDashboard}`,
    //     },
    //   ]
    //   : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "All Users",
          // count: 0,
          // icon: ImgPath.ActiveOrdersIcon,
          icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,
          path: `/${RouteUrls.AllUsers}`,
        },
      ]
      : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Payment Refund",
          // count: 0,
          // icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,

          // icon: <CurrencyExchange sx={{ fontSize: 45, color: '#c62828' }} />,
          icon: ImgPath.ActiveOrdersIcon,
          // icon: <CurrencyExchange sx={{ fontSize: 45, color: '#c62828' }} />,
          path: `/${RouteUrls.PaymentProcess}`,
        },
      ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
        {
          title: "Initiate Professional Payouts",
          // count: 0,
          // icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,

          icon: <CurrencyRupee sx={{ fontSize: 45, color: '#2e7d32' }} />,
          path: `/${RouteUrls.professionalUserListing}`,
        },
      ]
      : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Verify Professional Payouts",
          // count: 0,
          icon: <CurrencyRupee sx={{ fontSize: 45, color: '#0288d1' }} />,
          path: `/${RouteUrls.SuperAdminApproval}?type=professional`,
        },
      ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
        {
          title: "Initiate e-Mitra Payouts",
          icon: <CurrencyRupee sx={{ fontSize: 45, color: '#2e7d32' }} />,
          path: `/${RouteUrls.eMitraUsers}`,
        },
      ]
      : []),
    ...(myInfo.userType === "SUPERADMIN"
      ? [
        {
          title: "Verify e-Mitra Payouts",
          icon: <CurrencyRupee sx={{ fontSize: 45, color: '#0288d1' }} />,
          path: `/${RouteUrls.SuperAdminApproval}?type=emitra`,
        },
      ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
        {
          title: "Reward Redeem Requests",
          // count: 0, // You can fetch this count from your API later
          icon: <StarIcon sx={{ fontSize: 45, color: '#0288d1' }} />,
          path: `/${RouteUrls.RewardRedeemRequests}`,
        },
      ]
      : []),
    ...(!["ADMIN", "SUPERADMIN"].includes(myInfo.userType)
      ? [
        {
          title: "Raise a Complaint",
          icon: <SupportAgent sx={{ fontSize: 45, color: '#EF4444' }} />,
          path: `/${RouteUrls.raiseComplaint}`,
        },
      ]
      : []),
  ];
  useEffect(() => {
    handleOnLoad();

    const handleUpdate = () => {
      handleOnLoad();
    };

    window.addEventListener("notificationsUpdated", handleUpdate);

    let registered = false;
    const registerSignalR = async () => {
      try {
        await ensureConnected();
        if (connection) {
          connection.on("MessagesRead", handleUpdate);
          registered = true;
        }
      } catch (err) {
        console.warn("SignalR listener error in DashboardCards:", err);
      }
    };
    registerSignalR();

    return () => {
      window.removeEventListener("notificationsUpdated", handleUpdate);
      if (registered && connection) {
        connection.off("MessagesRead", handleUpdate);
      }
    };
  }, []);

  const handleOnLoad: () => void = async () => {
    setLoading(true);

    /* 
    // OLD CODE: FETCH DASHBOARD COUNTS BY ORDER TYPE (COMMENTED OUT)
    // Fetch counts for cards
    const res = await CaseApi.getDashboardCount();
    if (res?.success) {
      const newArr: DashboardCardType[] = res?.data
        ?.map((el: any) => {
          return {
            title: `${el?.orderTypeName} Orders`,
            count: el?.caseCount,
            icon: getCardIconByOrderTypeId(el?.orderTypeId),
            path: getCardPath(el),
          };
        })
        ?.filter((el: DashboardCardType) => (el.count ?? 0) > 0); // filter out cards with count 0
      setCards([...newArr, ...cardData]);
    }
    else {
      // If API fails, still show the static admin cards
      setCards(cardData);
    }
    */

    try {
      const userId = myInfo?.id;
      if (!userId) {
        setLoading(false);
        return;
      }
      const [orderRes, statusRes] = await Promise.all([
        AdminApi.OrderHistory(userId.toString(), 1, 10000, ""),
        StatusApi.getFinalStatuses()
      ]);


      const fData = Array.isArray(statusRes?.data) ? statusRes?.data : (statusRes?.data?.data || []);
      const finalStatuses: string[] = fData.map((s: string) => s.trim().toLowerCase());

      let activeCount = 0;
      let pendingCount = 0;
      let failedCount = 0;
      let completedCount = 0;
      let totalUnreadChatMsgs = 0;

      const isCaseCompleted = (statusName: string) => {
        if (!statusName) return false;
        return statusName.trim().toLowerCase() === "completed";
      };

      if (orderRes?.success && orderRes?.data?.data) {
        const rawOrders = orderRes.data.data;
        const filteredOrders = rawOrders.filter((order: any) => {
          // 1. Exclude Admin Support cases (orderTypeId === 53 or name === "admin support")
          const orderTypeName = (order.orderTypeName || order.orderType || "").trim().toLowerCase();
          if (order.orderTypeId === 53 || orderTypeName === "admin support") {
            return false;
          }

          // 2. Apply ODR filter conditions (matching ChatListComponent.tsx)
          const orderTypeStr = (order.orderTypeName || order.orderType || "").trim().toLowerCase();
          const isOdr = ["online mediation", "online arbitration", "arbitration", "online negotiation", "mediation", "negotiation"].some(type => orderTypeStr.includes(type));
          
          if (isOdr) {
            // Filter out rejected & pending respondent ODR cases for clients/respondents
            if (myInfo?.userType !== "ADMIN" && myInfo?.userType !== "SUPERADMIN") {
              const isRejected = order.respondentConsentStatus === "Rejected" || order.respondentConsentStatus === "Declined" || order.odrStatus === "REJECTED";
              if (isRejected) {
                return false;
              }
              const isClaimant = Number(order.clientId) === Number(myInfo?.id);
              const isRespondentUser = !isClaimant && myInfo?.userType !== "PROFESSIONAL";

              if (isRespondentUser) {
                const respondentStatus = (order.respondentConsentStatus || "").trim().toUpperCase();
                const isRespondentAccepted = respondentStatus === "CONFIRMED" || respondentStatus === "ACCEPTED" || respondentStatus === "GIVEN";
                if (!isRespondentAccepted) {
                  return false;
                }
              }
            }
            // Filter out pending ODR cases for professionals until they accept
            if (myInfo?.userType === "PROFESSIONAL") {
              const neutralStatus = (order.neutralConsentStatus || "").trim().toUpperCase();
              const isAccepted = neutralStatus === "CONFIRMED" || neutralStatus === "ACCEPTED" || neutralStatus === "GIVEN";
              if (!isAccepted) {
                return false;
              }
            }
          }

          return true;
        });

        filteredOrders.forEach((order: any) => {
          let status = order.casePaymentStatus?.trim().toLowerCase() || "pending";
          if (Number(order.casePrice) === 0) {
            status = "completed"; // treat 0 price as successfully paid
          }
          const processingStatus = order.currentProcessingStatusName?.trim() || "";
          const completed = isCaseCompleted(processingStatus);

          if (completed) {
            completedCount++;
          } else if (status === "paymentcompleted" || status === "success" || status === "completed") {
            activeCount++;
          } else if (status === "failed" || status === "paymentfailed" || status === "rejected" || status === "paymentnotcompleted" || status === "cancelled") {
            failedCount++;
          } else {
            pendingCount++;
          }
        });

        // Calculate unread chat messages count only for these filtered orders
        totalUnreadChatMsgs = filteredOrders.reduce((sum: number, c: any) => sum + (Number(c.unreadCount) || 0), 0);
      }

      const statusCards: any[] = [];

      if (activeCount > 0) {
        statusCards.push({
          title: "Active Orders",
          count: activeCount,
          unreadMessages: totalUnreadChatMsgs,
          icon: ImgPath.ActiveOrdersIcon,
          path: `/${RouteUrls.chat}`,
          state: { paymentStatus: "active" },
        });
      }

      // if (pendingCount > 0 && (myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN")) {
      //   statusCards.push({
      //     title: "Pending Orders",
      //     count: pendingCount,
      //     // MenuBook used as placeholder icon, can be customized later
      //     icon: <MenuBook sx={{ fontSize: 45, color: '#f57c00' }} />,
      //     path: `/${RouteUrls.chat}`,
      //     state: { paymentStatus: "pending" },
      //   });
      // }

      // if (failedCount > 0 && (myInfo?.userType === "ADMIN" || myInfo?.userType === "SUPERADMIN")) {
      //   statusCards.push({
      //     title: "Failed Orders",
      //     count: failedCount,
      //     // SupportAgent used as placeholder icon for failed
      //     icon: <SupportAgent sx={{ fontSize: 45, color: '#d32f2f' }} />,
      //     path: `/${RouteUrls.chat}`,
      //     state: { paymentStatus: "failed" },
      //   });
      // }

      if (completedCount > 0) {
        statusCards.push({
          title: "Completed Orders",
          count: completedCount,
          icon: <AssignmentTurnedIn sx={{ fontSize: 45, color: '#4caf50' }} />,
          path: `/${RouteUrls.chat}`,
          state: { paymentStatus: "completed" },
        });
      }

      setCards([...statusCards, ...cardData]);
    } catch (error) {
      console.error("Failed to fetch order history for dashboard cards", error);
      setCards(cardData);
    }

    setLoading(false);
  };

  const getCardPath: (el: any) => string = (el) => {
    if (el?.orderTypeName === "Active") {
      return `/${RouteUrls.chat}`;
    } else {
      return `/${RouteUrls.chat}/${el?.orderTypeId}`;
    }
  };

  const getCardIconByOrderTypeId = (orderTypeId: number): string => {
    try {
      return require(`../../Assets/Imgs/DashboardIcons/${"Icon" + orderTypeId}.png`);
    } catch {
      return require(`../../Assets/Imgs/DashboardIcons/defaultIcon.png`); // fallback image
    }
  };

  return (
    <Box overflow={"auto"} height={"100%"} sx={{ py: 2 }}>

      {/* ⚠️ NRI Phone Number Warning */}
      {myInfo?.userType === "NRIUSER" && String(myInfo?.phone) === "0000000000" && (
        <Box px={2} mb={2}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: "rgba(255, 243, 224, 0.7)",
              backdropFilter: "blur(10px)",
              border: "1px solid #ffb74d",
              borderRadius: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body1" color="warning.dark" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 500, mb: { xs: 1, sm: 0 } }}>
              ⚠️ Attention: Please update your Profile with a valid Phone Number.
            </Typography>
            <Button
              variant="contained"
              color="warning"
              onClick={() => navigate(`/${RouteUrls.userProfileForm}`)}
              sx={{ whiteSpace: "nowrap", textTransform: "none", borderRadius: "8px", fontWeight: 600 }}
            >
              Update Profile
            </Button>
          </Paper>
        </Box>
      )}

      {/* ⚠️ Professional Verification Warning */}
      {myInfo?.userType === "PROFESSIONAL" && !myInfo?.beProfessionalVerified && (
        <Box px={2} mb={2}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              bgcolor: "rgba(255, 243, 224, 0.7)",
              backdropFilter: "blur(10px)",
              border: "1px solid #ffb74d",
              borderRadius: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body1" color="warning.dark" sx={{ fontWeight: 500, mb: { xs: 1, sm: 0 } }}>
              ⚠️ Attention: Please update your Profile with all required information (Certificates, Degree, etc.) to get verified.
            </Typography>
            <Button
              variant="contained"
              color="warning"
              onClick={() => navigate(`/${RouteUrls.userProfileForm}`)}
              sx={{ whiteSpace: "nowrap", textTransform: "none", borderRadius: "8px", fontWeight: 600 }}
            >
              Update Profile
            </Button>
          </Paper>
        </Box>
      )}

      {/* 📘 Platform Guide Banner */}
      {["PROFESSIONAL", "USER", "CORPORATEUSER", "NRIUSER"].includes(myInfo?.userType) && (
        <Box px={2} mb={2}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              background: "linear-gradient(135deg, #283165 0%, #4f5891ff 100%)",
              color: "white",
              boxShadow: "0 8px 32px rgba(40, 49, 101, 0.2)",
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <MenuBook sx={{ mr: 2, color: '#4fc3f7', fontSize: 32 }} />
              <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '1.1rem', color: "white" }}>
                New to the platform? Read our Guide Booklet to get started!
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenGuide}
              sx={{
                bgcolor: "#201d4bff",
                color: "#ffffffff",
                whiteSpace: "nowrap",
                textTransform: "none",
                borderRadius: "10px",
                fontWeight: 700,
                px: 4,
                "&:hover": { bgcolor: "#4d46afff" }
              }}
            >
              Read Booklet
            </Button>
          </Paper>
        </Box>
      )}

      <Grid container spacing={4} px={2}>
        {loading ? (
          <Loader />
        ) : (
          cards.map(({ title, count, unreadMessages, icon, path, state }: any) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={title}>
              <Paper
                elevation={0}
                onClick={() => {
                  if (path === "contact") {
                    setContactDialogOpen(true);
                  } else if (path === "broadcast") {
                    setBroadcastDialogOpen(true);
                  } else if (path === "guide") {
                    handleOpenGuide();
                  } else if (path && path !== "#") {
                    navigate(path, { state });
                  }
                }}
                sx={{
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "24px",
                  height: "100%",
                  bgcolor: "white",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
                  cursor: "pointer",
                  overflow: "hidden",
                  position: "relative",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    borderColor: "#28316520",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "4px",
                    background: "linear-gradient(90deg, #283165, #4fc3f7)",
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                  },
                  "&:hover::before": {
                    opacity: 1,
                  }
                }}
              >
                {/* Icon Container */}
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    mr: 3,
                    borderRadius: "18px",
                    background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                    border: "1px solid #e2e8f0",
                    transition: "all 0.3s ease",
                    ".MuiSvgIcon-root": {
                      transition: "transform 0.3s ease",
                    },
                    "&:parent-hover .MuiSvgIcon-root": {
                      transform: "scale(1.1)",
                    }
                  }}
                >
                  {typeof icon === "string" ? (
                    <Box component="img" src={icon} alt={title} sx={{ width: "60%", height: "60%" }} />
                  ) : (
                    icon
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 500,
                      fontFamily: '"Outfit", sans-serif',
                      fontSize: "1.05rem",
                      color: "#64748b",
                      mb: 0.5,
                      lineHeight: 1.2
                    }}
                  >
                    {title}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontFamily: '"Inter", sans-serif',
                        fontSize: "1.8rem",
                        color: "#1e293b",
                        letterSpacing: "-0.5px"
                      }}
                    >
                      {count || 0}
                    </Typography>
                    {Number(unreadMessages) > 0 && (
                      <Chip
                        label={`${unreadMessages} unread`}
                        size="small"
                        sx={{ 
                          fontWeight: "bold", 
                          fontSize: "0.75rem", 
                          ml: 1.5, 
                          height: 24,
                          bgcolor: "#25D366",
                          color: "#ffffff",
                          boxShadow: "0 2px 6px rgba(37, 211, 102, 0.4)",
                          px: 0.5
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))
        )}

        <ContactUsDialog
          open={contactDialogOpen}
          onClose={() => setContactDialogOpen(false)}
        />
        <BroadcastNotificationDialog
          open={broadcastDialogOpen}
          onClose={() => setBroadcastDialogOpen(false)}
        />
      </Grid>

      {/* 📊 Corporate Dashboard section - only for Corporate users */}
      {myInfo?.id && myInfo?.userType?.toUpperCase() === "CORPORATEUSER" && (
        <CorporateBatchDashboard clientId={myInfo.id} />
      )}
    </Box>
  );
};

export default DashboardCards;
